import { style } from '@vanilla-extract/css';

export const link = style({
  wordBreak: 'break-word',
  fontWeight: 'var(--wt-inline-link-font-weight)',
  fontStyle: 'var(--wt-inline-link-font-style)',
  textDecoration: 'var(--wt-inline-link-underline) var(--wt-inline-link-underline-color)',
  color: 'var(--wt-inline-link-color)',
});
